// removed by extract-text-webpack-plugin
module.exports = {"container":"_3T08reOKGISprrR9DPpgdd","tabs":"_2gSsP8udYdJIOk2fY_9B1N","tab":"_22gpN_n1sT0hcflJe2uhOM","active":"_2SZKz9tFB6WIVjLe8ELml _22gpN_n1sT0hcflJe2uhOM","non-active":"y95IrdjSw0hmHnvVZPwhf _22gpN_n1sT0hcflJe2uhOM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/MobileTab.scss
// module id = 1237
// module chunks = 0